var MTIProjectId='3c5b3702-9664-4f96-b9d2-4d6cf70b9ddb';
(function() {
    var mtiTracking = document.createElement('script');
    mtiTracking.type='text/javascript';
    mtiTracking.async='true';
    mtiTracking.src=('https:'===document.location.protocol?'https:':'http:')+'//fast.fonts.net/t/trackingCode.js';
    (document.getElementsByTagName('head')[0]||document.getElementsByTagName('body')[0]).appendChild( mtiTracking );
})();


// WEBPACK FOOTER //
// ./src/Resources/ui/js/webfonts.js